import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackService, FeedbackServiceImpl } from '@/components/feedback/feedback.service';

export const feedbackModule = (bind: interfaces.Bind) => {
    bind(FeedbackService).to(FeedbackServiceImpl);
};
